

















import Vue from 'vue';
// not going to type popper
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Popper from 'vue-popperjs';
import 'vue-popperjs/dist/vue-popper.min.css';

export default Vue.extend({
  components: { Popper },
  computed: {
    arrowPlacement(): string {
      switch(this.arrowPosition) {
        case `left`:
          return `popper--arrow-left`;
        case `right`:
          return `popper--arrow-right`;
        default:
          return ``;
      }
    },
  },
  props: {
    arrowPosition: {
      default: ``,
      type: String,
    },
    options: {
      default: () => {},
      type: Object as () => unknown,
    },
    popperClass: {
      default: ``,
      type: String,
    },
    trigger: {
      default: `hover`,
      type: String,
    },
  },
});
